module.exports = __webpack_public_path__ + "static/media/logo-gilbues.23566f63.png";